export default {"src":"/_next/static/media/emojiIcon.feadb6b0.svg","height":16,"width":16};